export default "__VITE_ASSET__BAmTwKRj__"